import React from 'react'
import PropTypes from 'prop-types';
// import clsx from 'clsx';
import { connect } from 'react-redux'
import { fade, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Chip from '@material-ui/core/Chip';
import axios from 'axios'
import InvoiceDetails from './InvoiceDetail'
// import Toolbar from '@material-ui/core/Toolbar';
// import Typography from '@material-ui/core/Typography';
import { Paper, CircularProgress, IconButton } from '@material-ui/core';
// import Checkbox from '@material-ui/core/Checkbox';
// import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
// import DeleteIcon from '@material-ui/icons/Delete';
// import FilterListIcon from '@material-ui/icons/FilterList';
import moment from 'moment'
import { Link } from 'react-router-dom'
// import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import { socket } from '../SocketIo/Socket'
import VisibilityIcon from '@material-ui/icons/Visibility';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
// function createData(name, status, created, lastactivity, tourbooked) {
//   return { name, status, created, lastactivity, tourbooked };
// }
// const rows = [
//   createData('Tom Smith', 'New', '12/17/2019', null, null),
//   createData('Donut', 'Working', '12/18/2019', 51, 4.9),
//   createData('Eclair', 'New', '11/29/2019', 24, 6.0),
//   createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
//   createData('Gingerbread', 356, 16.0, 49, 3.9),
//   createData('Honeycomb', 408, 3.2, 87, 6.5),
//   createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
//   createData('Jelly Bean', 375, 0.0, 94, 0.0),
//   createData('KitKat', 518, 26.0, 65, 7.0),
//   createData('Lollipop', 392, 0.2, 98, 0.0),
//   createData('Marshmallow', 318, 0, 81, 2.0),
//   createData('Nougat', 360, 19.0, 9, 37.0),
//   createData('Oreo', 437, 18.0, 63, 4.0),
// ];

function desc(a, b, orderBy, isDate) {
  // console.log('desc: ', a)
  // console.log('desc b: ', b)
  if (isDate) {
    if (b[orderBy] < a[orderBy] || b[orderBy] == null) {
      // console.log('B is < A')
      return -1;
    }
    if (b[orderBy] > a[orderBy] || a[orderBy] == null) {
      // console.log('B is > A')
      return 1;
    }
    // console.log('B is ? A')
    // console.log('A: ', a[orderBy])
    // console.log('B: ', b[orderBy])
    return 0;
  } else {
    if (b[orderBy] < a[orderBy] || b[orderBy] == null) {
      return -1;
    }
    if (b[orderBy] > a[orderBy] || a[orderBy] == null) {
      return 1;
    }
    return 0;
  }
}

function stableSort(array, cmp) {
  // console.log('Stable sort: ', array)
  // console.log('CMP: ', cmp)
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  if (orderBy==='lastUpdated') {
    // console.log('Last Updated')
    return order === 'desc' ? (a, b) => desc(a, b, orderBy, true) : (a, b) => -desc(a, b, orderBy, true);
  } else {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
  }
  
}

const headCells = [
  { id: 'invoiceNumber', numeric: false, disablePadding: true, label: 'Invoice Number' },
  { id: 'jobName', numeric: false, disablePadding: true, label: 'Job Name (Number)' },
  { id: 'amount', numeric: false, disablePadding: true, label: 'Amount' },
  { id: 'taxAmount', numeric: false, disablePadding: true, label: 'Tax Amount' },
  { id: 'lateFeeAmount', numeric: false, disablePadding: true, label: 'Late Fee Amount' },
  { id: 'totalDue', numeric: false, disablePadding: true, label: 'Total Due' },
  { id: 'balance', numeric: false, disablePadding: true, label: 'Balance' },
  // { id: 'status', numeric: false, disablePadding: true, label: 'Status' },
  { id: 'notes', numeric: false, disablePadding: true, label: 'Notes' },
  { id: 'created_at', numeric: false, disablePadding: true, label: 'Created' },
  { id: 'dueDate', numeric: false, disablePadding: true, label: 'Due Date' },
  // { id: 'crewname', numeric: false, disablePadding: false, label: 'Crew' }
];

function EnhancedTableHead(props) {
  // console.log('Got our props', props)
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    // console.log('Sort Property: ', property)
    // console.log('sort event; ', event)
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox">
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all leads' }}
          />
        </TableCell> */}
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={order}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  table: {
    minWidth: 400,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fakeLink: {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: 'blue'
  }
}));

const defaultStateValues = {
  pdf: ''
}

function EnhancedTable(props) {
  // console.log('invoice List Props: ', props)
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('-created');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense] = React.useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [searchValue, setsearchValue] = React.useState('');
  const [searchMatches, setsearchMatches] = React.useState(0);
  const [invoiceDetailsOpen, setinvoiceDetailsOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false)
  const [invoice, setInvoice] = React.useState({});
  const [crewList, setCrewList] = React.useState([]);
  const [serviceList, setServiceList] = React.useState([]);
  const [filteredRows, setFilteredRows] = React.useState([])
  const [showOpenInvoicesToggle, setShowOpenInvoicesToggle] = React.useState(false)
  const [state, setState] = React.useState(defaultStateValues)
  // setLeads(props.leads)
  // let clients  = []
  // if (clients && clients.length > 0) clients = props.clients
  // console.log('Clients on table: ', clients)
  // const rows = leads
  const [rows, setRows] = React.useState([]);
  // setRows(leads)
  // setRows(leads)
  // useEffect(() => {
  //   // console.log('Use effect LEADS', leads)
  //   axios
  //     .get(
  //       `${url}/api/tours/getAll`
  //       )
  //     .then(({ data }) => {
  //       // console.log(data)
  //       setLeads(data)
  //     }).catch(function (err) {
  //       // console.log('Error getting stuff', err)
  //     });
  // }, [leads]);

  React.useEffect(() => {
    let isMounted = true
  // console.log('Invoices Have  changed', rows)
  // console.log(props)
    if (props.stateData && props.stateData.itemToOpen && props.stateData.itemToOpen === 'Invoice' && props.stateData.openId && rows && rows.length) {
    // console.log('Open this bitch', props.stateData.openId)
      // handleClick
      let index = rows.findIndex(item => (item._id === props.stateData.openId))
    // console.log('Open Invoice Index', index)
    // console.log(rows[index])
      if (index > -1) {
      // console.log('Weoot mother fuckin woot')
        if (isMounted) {
          openModal(rows[index])
          // setActiveEstimate(rows[index])
          // setShowModal(true)
        }
      }
    }

    return () => {
      isMounted = false
    }
  }, [rows])

  const getInvoicesForClient = async (client) => {
    // console.log('Get Client invoices')
    setLoading(true)
    // console.log('Get invoices for this guy: ', client)
    const response = await axios.get(`${props.url}/api/invoice/getAllClientInvoices?id=${client._id}`)
     // console.log('Invoices!!', response)
     if (response && response.data) {
      let invoices = response.data
      setRows(invoices);
      setFilteredRows(invoices)
      setLoading(false)
     } else {
       // console.log('Something went wrong')
       props.notification({
        type: 'warning',
        title: 'We Ran Into A Problem!',
        message: 'An Error Occurred Trying to Get Invoics from Arbor Gold - please hang tight while we attempt to resolve it.'
      })
     }
     
  }

  React.useEffect(() => {
    // console.log('Use effectset  InvoiceList', props.client)
    if (props.client && props.client._id) getInvoicesForClient(props.client)
    console.log('Subscribe to invoiceList for client...', props.client._id)
    socket.on(`${props.client._id}-invoiceList`, function (msg) {
      console.log('GOT A SOCKET MESSAGE to the INVOICE LIST!!: ', msg)
      getInvoicesForClient(props.client)



      
      // if (msg && msg.newInvoice && msg.newInvoice._id) {
      //   // getInvoicesForClient(props.client)
      //   console
      //   let invoices = rows
      //   invoices.unshift(msg.newInvoice)
      //   setRows(invoices)
      //   setFilteredRows(invoices)
      // } else {
      //   getInvoicesForClient(props.client)
      // }
      // setStatementMessage(msg.message)

      // props.notification({
      //   type: 'success',
      //   title: 'Statement Update',
      //   message: msg.message
      // })
    })
    return () => {
      console.log('Unsubscribe from Customer invoicelist socket...')
      socket.off(`${props.client._id}-invoiceList`)
    }
  }, [])

  React.useEffect(() => {
    if (props?.stateData?.itemToOpen === 'PDF' && props?.stateData?.pdf) {
      console.log('Gotta open this pdf...', props.stateData)
      if (props?.stateData?.depositInvoice) openModal(props.stateData.depositInvoice, props.stateData.pdf)
      // openModal()
    }
  }, [props?.stateData])

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    // console.log('Set order by property: ' + property + ' in ' + isDesc + ' order')
    setOrderBy(property);
  };

  function currencyFormat(num) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
 }

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n._id);
      // console.log(newSelecteds)
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    // console.log('handle click ', name)
    // console.log('Index: ', selectedIndex)
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const handleChangeDense = event => {
  //   setDense(event.target.checked);
  // };

  const isSelected = name => selected.indexOf(name) !== -1;

  const emptyRows = 0// rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const filterOut = (r, searchText) => {
    // console.log('FIlter out: ', r)
    let string = searchText
    let newArr = []
    r.filter(o => {
      // console.log('Object:  ', o)
      Object.keys(o).some(k => {
        // console.log(o[k])
        if(o[k]) {
          // console.log('OK: ', o[k])
          let str = o[k].toString().toLowerCase() 
          // console.log(str)
          if (str.includes(string.toLowerCase())) {
            // console.log('Mathc')
            return newArr.push(o)
          } else {
            return null
          }
        } else {
          return null
        }
      })
      // return newArr
    })
    // setsearchMatches(newArr.length)
    // return newArr
    setFilteredRows(newArr)
    // setsearchMatches(newArr.length)
    // let newArr = r.filter(i => {
    //   if (i.includes('test')) return i
    // })
    // return newArr
    // return r.filter((obj)=>{
    //   return Object.keys(obj).reduce((acc, curr)=>{
    //         return acc || obj[curr] ? obj[curr].toString().toLowerCase().includes(string) : obj[curr];
    //   }, false);
    // })
  }
  
  const handleChange = (name) => (event) => {
    // console.log('Searching: ', event.target.value)
    setPage(0)
    setsearchValue(event.target.value)
    if (event.target.value === '') {
      setFilteredRows(rows)
    } else {
      filterOut(rows, event.target.value)
    }
  }

  const openModal = (invoice, pdf) => {
    // console.log(event)
    // e.preventDefault;
  // console.log('Open INVOICEDETAIL modal: ', invoice)
    // props.openModal(invoice)
    setInvoice(invoice)
    setinvoiceDetailsOpen(true)
    if (pdf) {
      console.log('Also display the PDF...')
      setState(prevState => ({...prevState, pdf: pdf }))
    }
  }

  const invoiceDetailsResponse = (s, t) => {
    // console.log('Response from our invoice details!!', s)
    if (s === 'Deleted') {
      // console.log('Deleted invoice - remove it from the list', t)
      let index = rows.findIndex(row =>  (row._id.toString() === t._id.toString()))
      // console.log('INDEX: ', index)
      // console.log(rows[index])
      let invoices = rows
      invoices.splice(index, 1)
      setRows(invoices)
      setinvoiceDetailsOpen(false)
    } else if (s === 'Payment Made') {
      // console.log('Payment made baby!!!', t)
      let index = rows.findIndex(row =>  (row['_id'] === t['_id']))
      // console.log('INDEX: ', index)
      // console.log(rows[index])
      let invoices = rows
      invoices[index] = t
      // .splice(index, 1)
      // invoices.push(t)
      // console.log('Invoices with updated payment...', invoices)
      setRows(invoices)
      // setFilteredRows(invoices)
    } else {
      setinvoiceDetailsOpen(false)
    }
  }

  const showPaymentDetails = async () => {
    // console.log('Show Payment Details')
    setLoading(true)
    const response = await axios.get(`${props.url}/api/invoice/getAllInvoicesAndAssociatedPayments?id=${props.client._id}`)
    // console.log('Invoices With Payments!!', response)
    setRows(response.data)
    setFilteredRows(response.data)
    setLoading(false)
  }
  
  const NotesDetails = (data) => {
    let row = data.row
    // console.log('Notes Details: ', row)
   let html = ''
   if (row.transactionId) {
     html = (
       `Transaction ID: ${row.transactionId} (${row.accountType} - ${row.accountNumber})`
     )
   } else if (row.accountType && row.accountNumber) {
     html = (
       `${row.accountType} - ${row.accountNumber}`
     )
   } else {
     html = row.notes
   }
   return html
  }
  
  const PaymentDetails = (props) => {
    if (props.payments && props.payments.length > 0) {
      return props.payments.map(pmt => (
        <TableRow style={{backgroundColor: '#ccc'}}>
          <TableCell></TableCell>
          <TableCell padding="none">Payment On Invoice # {pmt.invoiceNumber}: </TableCell>
          <TableCell padding="none">{currencyFormat(pmt.amount || 0)}</TableCell>
          <TableCell padding="none">{(pmt.totalCharge && pmt.totalCharge > 0) ? currencyFormat(pmt.totalCharge) : ''}</TableCell>
          <TableCell padding="none">{pmt.status}</TableCell>
          <TableCell colSpan={2} padding="none"><NotesDetails row={pmt} /></TableCell>
          <TableCell padding="none">{moment(pmt.paidDate).format('MM/DD/YYYY')}</TableCell>
        </TableRow>

      ))
    } else {
      return null
    }
    
  }
  const chipBgColor = (status) => {
    let bgColor = '#ccc'
    if (status === 'Pending') bgColor='#ddd'
    if (status === 'Not Paid') bgColor='#f1c40f'
    if (status === 'Paid') bgColor='green'
    if (status === 'Bad Debt') bgColor='red'
    if (status === 'Show All') bgColor='#617563'
    if (status === 'Show Open') bgColor = '#dbd800'
    return bgColor
  }

  const showOpenInvoices = () => {
    let toShow = showOpenInvoicesToggle
    setShowOpenInvoicesToggle(!toShow)
    if (toShow) {
      // Show ALl
      setFilteredRows(rows)
    } else {
      let arr = []
      // Show Non Paid Only
      let openInvoices = rows.map(item => {
        if (item && (item.status === 'Not Paid' || item.status === 'Partially Paid')) {
          arr.push(item)
        }
      })
      setFilteredRows(arr)
    }
  }

  return (
    <div className={classes.root}>
      <InvoiceDetails pdf={state.pdf} client={props.client} deposits={props.deposits} entity={props.entity} contacts={props.contacts} credits={props.credits} paymentProfiles={props.paymentProfiles} invoice={invoice} crewList={crewList} serviceList={serviceList} invoiceDetailsResponse={invoiceDetailsResponse} open={invoiceDetailsOpen} />
      { loading?  <CircularProgress color="primary" size={ 36 } /> : 
      <Paper className={classes.paper}>
       
          Total Invoices {rows.length}
          &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
          <Tooltip title="View Payment Details" placement="top">
            <IconButton onClick={showPaymentDetails}  alt="Show Payment Details" aria-label="Show Payment Details">
                <VisibilityIcon />
            </IconButton>
          </Tooltip>
          {
            showOpenInvoicesToggle ? (
              <Tooltip title="Show All Invoices" placement="top" style={{marginLeft: 50}}>
                <Chip onClick={showOpenInvoices}  style={{color: '#fff', background: chipBgColor('Show All') }} size="small" label="Show All Invoices" />
                {/* <IconButton onClick={showOpenInvoices}  alt="Show All Invoices" aria-label="Show All Invoices">
                    <AttachMoneyIcon />
                </IconButton> */}
              </Tooltip>
            ) : (
              <Tooltip title="Show Open Invoices" placement="top" style={{marginLeft: 50}}>
                {/* <IconButton onClick={showOpenInvoices}  alt="Show Open Invoices" aria-label="Show Open Invoices">
                    <AttachMoneyIcon />
                </IconButton> */}
                <Chip onClick={showOpenInvoices}  style={{color: '#fff', background: chipBgColor('Show Open') }} size="small" label="Show Open Invoices" />
              </Tooltip>
            )
          }


        {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
        <div className={classes.search}>
            <div >
              <SearchIcon /> Search { searchValue ? `(${filteredRows.length} Matches)` : ''}
            </div>
            <input name="search" value={ searchValue } onChange={ handleChange('search') } type="text"></input>
          </div>
        <div className={classes.tableWrapper} style={{margin: '10px'}}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size='small'
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {stableSort(filteredRows, getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  // console.log('Invoice LIST map: ', row)
                  const isItemSelected = isSelected(row._id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  let isPastDue = false
                  if (row.status === 'Not Paid' && (moment(row.dueDate) < moment(new Date()))) isPastDue = true
                  // setsearchMatches(rows.length)
                  // console.log(row)
                  // console.log('Is Past DUe: ', isPastDue)
                  return (
                    <React.Fragment key={index}>
                      <TableRow
                        hover
                        // onClick={event => handleClick(event, row.number)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row._id}
                        selected={isItemSelected}
                        component="tr"
                        style={(isPastDue) ? { padding: '3px', backgroundColor: 'rgba(223, 38, 38, .4)', border: '1px solid #d7393f' } : null}
                      >
                        <TableCell component="td" id={labelId} scope="row" padding="none" >
                          <span className={classes.fakeLink} onClick={() => openModal(row)}>{row.invoiceNumber}</span>
                          &nbsp;&nbsp;&nbsp;&nbsp;<Chip style={{color: '#fff', background: chipBgColor(row.status) }} size="small" label={row.status} />
                        </TableCell>
                        <TableCell component="td" id={labelId} scope="row" padding="none">
                          { row.jobName } ({ row.jobNumber})
                        </TableCell>
                        <TableCell component="td" id={labelId} scope="row" padding="none">
                          { row.amount ? currencyFormat(parseFloat(row.amount)) : '$0.00' }
                        </TableCell>
                        <TableCell component="td" id={labelId} scope="row" padding="none">
                          { row.taxAmount ? currencyFormat(parseFloat(row.taxAmount)) : '$0.00' }
                        </TableCell>
                        <TableCell component="td" id={labelId} scope="row" padding="none">
                          { row.lateFeeAmount ? currencyFormat(parseFloat(row.lateFeeAmount)) : '$0.00' }
                        </TableCell>
                        <TableCell component="td" id={labelId} scope="row" padding="none">
                          { row.totalDue ? currencyFormat(parseFloat(row.totalDue)) : '$0.00' }
                        </TableCell>
                        <TableCell component="td" id={labelId} scope="row" padding="none">
                          { row.balance ? currencyFormat(parseFloat(row.balance)) : '$0.00' }
                        </TableCell>
                      
                        {/* <TableCell component="td" id={labelId} scope="row" padding="none">
                          {row.status}
                        </TableCell> */}
                        <TableCell component="td" id={labelId} scope="row" padding="none">
                          {row.notes}
                        </TableCell>
                        <TableCell component="td" id={labelId} scope="row" padding="none">
                          {moment.utc(row.created_at).local().format('MM/DD/YYYY')}
                        </TableCell>
                        <TableCell component="td" id={labelId} scope="row" padding="none">
                          {moment.utc(row.dueDate).local().format('MM/DD/YYYY')}
                        </TableCell>
                      </TableRow>
                      { row.payments ? <PaymentDetails payments={row.payments} /> : '' }
                    </React.Fragment>
                  );
                })
              }
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          component="div"
          count={filteredRows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          // onPageChange={handleChangePage}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      }
      {/* <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      /> */}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    authenticated: state.authenticated,
    notification: state.notification,
    url: state.url
  }
}

export default React.memo(connect(mapStateToProps)(EnhancedTable))

